import { createSlice } from '@reduxjs/toolkit';
import { IInitialAdminIssuesState } from './types';

const SLICE_NAME = 'ADMIN_ISSUES_SLICE';

export const initialState: IInitialAdminIssuesState = {
  loading: false,
  error: '',
  data: null,
  archived: null,
};

const adminUserSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchAdminIssuesError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchAdminIssues: (state) => {
      state.loading = true;
      state.error = '';
    },
    fetchAdminIssuesSearch: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchAdminIssuesSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
    fetchAdminIssuesArchived: (state) => {
      state.loading = true;
      state.error = '';
    },
    fetchAdminIssuesArchivedSuccess: (state, { payload }) => {
      state.loading = false;
      state.archived = payload;
    },
    putAdminIssuesStatus: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    putAdminIssuesArchiveSaga: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    putAdminIssuesArchiveSuccessSaga: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
    putAdminIssuesStatusSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
  },
});

export default adminUserSlice;
